import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'datepipe'
})
export class DatePipe implements PipeTransform {

  transform(date: string): string {
    if (date) {
      let dateConverted = new Date(date);
      let day = dateConverted.getDate().toString();

      if (day.length == 1)
        day = "0" + day;

      let month = (dateConverted.getMonth() + 1).toString();
      if (month.length == 1)
        month = "0" + month;

      let year = dateConverted.getFullYear();

      return day + '/' + month + '/' + year;
    } else {
      return '';
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/_pipes/date.pipe.ts